module.exports = __webpack_public_path__ + "static/img/Eureka_logo_y_semicírculo.503be99d.svg";